import axios from 'axios';

const API = axios.create({
  baseURL: 'http://localhost:8089/PPSignSDK/',
  timeout: 10 * 1000,
});

let isPolling = false;

function startPolling(callback) {
  isPolling = true;

  (async function poll() {

    if (!isPolling) {
      return;
    }

    let response = await API.get('GetInks?_t=' + (new Date()).getTime());
    let dataInfos = JSON.parse(response.data);
    dataInfos.forEach(value => {
      if (value.EventType === 0) {
        callback('data:image/png;base64,' + value.Image);
      }
    });

    setTimeout(() => {
      poll()
    }, 50);;

  })();
}

function stopPolling() {
  isPolling = false;
}

export default {
  initDevice({ width = 500, height = 380, drawing }) {
    return API.get(`InitialDevice?id=2&width=${width}&height=${height}`).then(response => {
      if (response.data === true) {
        this.setPenWidth(1);
        startPolling(drawing);

        return true;
      }

      return false;
    }).catch(error => {
      console.log('Init failed.');

      return false;
    });
  },

  uninitDevice() {
    stopPolling();

    return API.get('UninitialDevice?id=2').then(response => {
      return response.data === true;
    }).catch(error => {
      console.log('Fail to uninit device.')
    })
  },

  setPenWidth(width = 1) {
    return API.get(`SetPenWidth?Width=${width}`);
  },

  clear() {
    return API.get('Clear');
  },
}
